import React from 'react';
import { color } from '../constants';

const LoginLoader = () => (
    <div className='login-loader'>
        <Icon />
        <div className='login-loader-text'>Loading...</div>
    </div>
)

const Icon = ({ borderColor = color.primary }) => (
    <div className='login-loader-icon' style={{ borderColor: `transparent ${borderColor} ${borderColor}` }}>
    </div>
)

export default LoginLoader;